// ─── CONSEQUENCE PROTOCOL · CENTRAL CONFIGURATION ───────────────────────────
// Single source of truth for brand + links. Update here, everywhere follows.

export const SITE = {
  projectName: "Consequence Protocol",
  name: "CONSEQUENCE",
  ticker: "$CONSEQ",
  tickerPlain: "CONSEQ",
  network: "ARC",
  // Official $CONSEQ contract (ARC) — every CA surface reads from here.
  contractAddress: "0x5eb422e53e5e507B819b9DA7A1113Ffa4cA90087",
  xUrl: "https://x.com/CONSEQProtocol",
  buyUrl: "https://lift.fun/token/0x5eb422e53e5e507B819b9DA7A1113Ffa4cA90087",
  buyLabel: "LIFT.FUN",
  chartUrl: "https://dexscreener.com/arc/0xf48cc865c0396cdf0e1d1906acc3fe0b8f673927503e5292ab7a44c975f5a0c5",
  chartLabel: "DEXSCREENER",
  website: "https://conseqprotocol.xyz",
  tagline: "Don’t prove that you worked. Prove that your work mattered.",
  positioning: "The Outcome Layer for Autonomous Economies.",
  description:
    "Consequence Protocol is an outcome verification layer designed to measure what actions actually achieve — transforming verified consequences into reputation, trust, and economic access.",
  bootStorageKey: "conseq_boot_complete",
} as const;

export type SiteConfig = typeof SITE;

/** Wallet/connect UX stays disabled until the real CA is configured. */
export const isCaLive = (SITE.contractAddress as string) !== "COMING SOON";

/** Original supplied brand assets — served as real image files, never recreated. */
export const assets = {
  logo: "/assets/consequence-logo.png",
  banner: "/assets/consequence-banner.webp",
  art: "/assets/consequence-art.webp",
  artFallback: "/assets/consequence-art.png",
  ogImage: "/assets/og-image.jpg",
} as const;
